import { Component, input } from '@angular/core';
import { IEventDateBM, IEventInfoResourcePropertyBm, IEventInfoResourceResponseBm } from '@outlook-addin/cue-http';
import { translation } from '@cue/translations';
import { cueExternalLink, cueArrowRight, cueClose, cueCheck, IconComponent } from '@cue/ui/icons';
import {
  AssignToPipe,
  AssignToTranslateKeyToPipe,
  PhotosToFilePipe,
  ResourceExternalUrlPipe,
} from '../../shared/pipes';
import { TranslocoPipe } from '@jsverse/transloco';
import { ResourceMapComponent } from '../resource-map/resource-map.component';
import { ImageComponent } from '@cue/images';
import { AddinConfigService } from '@outlook-addin/shared';
import { FileGalleryComponent } from '@cue/ui/file-gallery';
import { hasResourcePropertyValue } from '../../shared/utils/resource-property.utils';

@Component({
  selector: 'addin-resource-detail',
  templateUrl: './resource-detail.component.html',
  styleUrls: ['./resource-detail.component.scss'],
  imports: [
    AssignToPipe,
    IconComponent,
    AssignToTranslateKeyToPipe,
    TranslocoPipe,
    ResourceExternalUrlPipe,
    ResourceMapComponent,
    FileGalleryComponent,
    PhotosToFilePipe,
  ],
})
export class ResourceDetailComponent {
  ICONS = {
    cueExternalLink,
    cueArrowRight,
    cueClose,
    cueCheck,
  };

  currentImage = undefined;
  translation = translation;
  start = input<IEventDateBM>();
  end = input<IEventDateBM>();
  resource = input<IEventInfoResourceResponseBm>();
  newMapFile = input('');
  protected canShowLinkToAssist: boolean;

  constructor(private configService: AddinConfigService) {
    this.canShowLinkToAssist = !this.configService.value.configuration.isCAFromAddin;
  }

  protected getEventDateTime(date?: IEventDateBM): string {
    const value = date?.dateTime as Date | string | undefined;
    if (value == null) {
      return '';
    }

    return value instanceof Date ? value.toISOString() : value;
  }

  getSimpleFiltersByResourceTypeId(detail: IEventInfoResourceResponseBm) {
    return this.getFiltersFromNavigationDetail(detail).filter((x) => x.dataTypeId !== 5);
  }

  private getFiltersFromNavigationDetail(
    detail: IEventInfoResourceResponseBm
  ): { name: string; value: unknown; dataTypeId: number }[] {
    return detail.properties
      .map((property) => ({
        name: property.name,
        dataTypeId: property.dataTypeId,
        value: this.getValueFromProperty(property),
      }))
      .filter((property) => hasResourcePropertyValue(property.value));
  }

  private getValueFromProperty(property: IEventInfoResourcePropertyBm): unknown {
    switch (property.dataTypeId) {
      case 1: {
        return property.valueBoolean;
      }
      case 2: {
        return property.valueNumber;
      }
      case 3: {
        return property.valueDecimal;
      }
      case 4: {
        return property.valueText;
      }
      case 5: {
        return property.valueChoices;
      }
      default:
        return null;
    }
  }

  navigateToResourceDetailInAssist(url: string) {
    window.open(url, '_blank');
  }
}
